import React from 'react';
import ProxyReservationCreate from 'pages/counselor/calendar/reservation-create/ReservationCreate';
import Routes from 'routes';

const ReservationCreate = () => {
    return <ProxyReservationCreate redirectTo={Routes.private.ADMIN_CALENDAR.path} />;
};

export default ReservationCreate;
